import dispatchEvent from "../components/dispatchEvent";
import {EVENT_ON_CART_ERROR, EVENT_ON_ORDER_UPDATE} from "./consts";

const axios = require('axios');

export default (id, quantity, callback) => {

    if (quantity > 0) {
        axios.post('orders-api/add-product', {
            product: id,
            quantity: quantity
        }).then((response) => {
            if (response.data.errors) {
                dispatchEvent(EVENT_ON_CART_ERROR, response.data.errors);
            }
            dispatchEvent(EVENT_ON_ORDER_UPDATE, response.data);
            if (callback) {
                callback(response.data);
            }
        })
    } else {
        axios.post('orders-api/remove-product', {
            product: id
        }).then((response) => {
            if (response.data.errors) {
                dispatchEvent(EVENT_ON_CART_ERROR, response.data.errors);
            }
            dispatchEvent(EVENT_ON_ORDER_UPDATE, response.data);
            if (callback) {
                callback(response.data);
            }
        })
    }

}
